import {
  HomeIcon,
  EmbedIcon,
  EventListenersIcon,
  FiltersIcon,
  FlipHorizontalIcon,
  SamplesIcon,
  UIThemeIcon,
  UXInteractivityIcon,
  APIIcon,
} from 'src/components/RemixIcons/generated/remixIcons';
import InteractivityBanner from 'src/components/Banners/InteractivityBanner/InteractivityBanner';
import EmbedOptionsBanner from 'src/components/Banners/EmbedOptionsBanner/EmbedOptionsBanner';
import ThemesBanner from 'src/components/Banners/ThemesBanner/ThemesBanner';
import CrossVisualFilteringBanner from 'src/components/Banners/CrossVisualFilteringBanner/CrossVisualFilteringBanner';
import EmbedApiBanner from 'src/components/Banners/EmbedApiBanner/EmbedApiBanner';
import EventListenersBanner from 'src/components/Banners/EventListenersBanner/EventListenersBanner';

export var COMMON_NAV_MENU_ITEMS = [
  {
    path: '/',
    name: 'Home',
    pageTitle: 'Welcome',
    headerTitle: 'Embedded Analytics Playground',
    category: 'Home',
    icon: <HomeIcon></HomeIcon>,
  },
  {
    path: '/discovery/embed-options',
    name: 'Embed Options',
    pageTitle: 'Embed',
    headerTitle: 'Embedded Analytics',
    category: 'Embed',
    icon: <EmbedIcon></EmbedIcon>,
    bannerComponent: <EmbedOptionsBanner></EmbedOptionsBanner>,
    bannerText: 'You Have Ultimate Control',
  },
  {
    path: '/discovery/ux-interactivity',
    params: '?dashboardIpOverrides=true&embedComponentType=dashboard',
    name: 'UX Interactivity',
    pageTitle: 'Interactivity',
    headerTitle: 'Embedded Analytics',
    category: 'UI/UX customization',
    icon: <UXInteractivityIcon></UXInteractivityIcon>,
    bannerComponent: <InteractivityBanner></InteractivityBanner>,
    bannerText: 'Self-service for Any Users',
  },
  {
    path: '/discovery/ui-themes',
    name: 'UI Theme',
    pageTitle: 'Themes',
    headerTitle: 'Embedded Analytics',
    category: 'UI/UX customization',
    icon: <UIThemeIcon></UIThemeIcon>,
    bannerComponent: <ThemesBanner></ThemesBanner>,
    bannerText: 'Limitless Customization',
  },
  {
    path: '/discovery/cross-visual-filtering',
    params: '?crossVisualFiltersPublish=true&embedComponentType=dashboard',
    name: 'Cross-Visual Filtering',
    pageTitle: 'Cross-Visual Filtering',
    headerTitle: 'Embedded Analytics',
    category: 'Advanced features',
    icon: <FiltersIcon></FiltersIcon>,
    bannerComponent: <CrossVisualFilteringBanner></CrossVisualFilteringBanner>,
    bannerText: 'Faster Time to Insights',
  },
  {
    path: '/discovery/embed-api',
    params: '?embedComponentType=visual-builder&listVisuals=true',
    name: 'Embed API',
    pageTitle: 'Embed API',
    headerTitle: 'Embedded Analytics',
    category: 'Advanced features',
    icon: <APIIcon></APIIcon>,
    bannerComponent: <EmbedApiBanner></EmbedApiBanner>,
    bannerText: 'Power to the Power User',
  },
  {
    path: '/discovery/event-listeners',
    name: 'Event Listeners',
    params: '?embedComponentType=dashboard&eventListeners=true',
    pageTitle: 'Event Listeners',
    headerTitle: 'Embedded Analytics',
    category: 'Advanced features',
    icon: <EventListenersIcon></EventListenersIcon>,
    bannerComponent: <EventListenersBanner></EventListenersBanner>,
    bannerText: 'A Cohesive Analytics Experience',
  },
  {
    path: '/my-samples',
    name: 'My Collection',
    category: 'Samples',
    pageTitle: 'My Collection',
    headerTitle: 'Samples',
    icon: <SamplesIcon></SamplesIcon>,
  },
  {
    name: 'Compare',
    category: 'How We Compare To',
    icon: <FlipHorizontalIcon></FlipHorizontalIcon>,
    children: [
      {
        name: 'Tableau',
        children: [
          {
            path: '/tableau/embed-samples',
            name: 'Embedding',
            pageTitle: 'Embedding',
            headerTitle: 'Tableau',
          },
          {
            path: '/tableau/multi-tenancy',
            name: 'Multi-Tenancy',
            pageTitle: 'Multi-Tenancy',
            headerTitle: 'Tableau',
          },
          {
            path: '/tableau/pixel-perfect-reporting',
            name: 'Pixel Perfect Reporting',
            pageTitle: 'Pixel Perfect Reporting',
            headerTitle: 'Tableau',
          },
          {
            path: '/tableau/white-label',
            name: 'White-Labeling and Theming',
            pageTitle: 'White-Labeling and Theming',
            headerTitle: 'Tableau',
          },
        ],
      },
      {
        name: 'Crystal Reports',
        children: [
          {
            path: '/crystal-reports/overview',
            name: 'Overview',
            pageTitle: 'Overview',
            headerTitle: 'Crystal Reports',
          },
          {
            path: '/crystal-reports/architecture-deployment',
            name: 'Architecture & Deployment',
            pageTitle: 'Architecture & Deployment',
            headerTitle: 'Crystal Reports',
          },
          {
            path: '/crystal-reports/embedding-apis',
            name: 'Embedding & APIs',
            pageTitle: 'Embedding & APIs',
            headerTitle: 'Crystal Reports',
          },
          {
            path: '/crystal-reports/multi-tenancy',
            name: 'Multi-Tenancy',
            pageTitle: 'Multi-Tenancy',
            headerTitle: 'Crystal Reports',
          },
          {
            path: '/crystal-reports/self-service-reporting',
            name: 'Self-Service',
            pageTitle: 'Self-Service Reporting',
            headerTitle: 'Crystal Reports',
          },
          {
            path: '/crystal-reports/reporting-exporting-capabilities',
            name: 'Capabilities',
            pageTitle: 'Reporting and Exporting Capabilities',
            headerTitle: 'Crystal Reports',
          },
          {
            path: '/crystal-reports/summary',
            name: 'Summary',
            pageTitle: 'Summary',
            headerTitle: 'Crystal Reports',
          },
        ],
      },
    ],
  },
];

const HIDDEN_NAV_ROUTE_ITEMS = [
  {
    path: '/crystal-reports/live-demo',
    pageTitle: 'Live Demo',
    headerTitle: 'Crystal Reports',
  },
];

// Yields a flat list that includes both parent items and any nested children.
// Consumers that look up a route by `path` (e.g. page title resolver, banner
// resolver) should use this so children remain discoverable after the menu
// was restructured into groups.
const flattenNavItems = (items) =>
  items.flatMap((item) => [
    item,
    ...(item.children ? flattenNavItems(item.children) : []),
  ]);

export const getFlatNavMenuItems = () => [
  ...flattenNavItems(COMMON_NAV_MENU_ITEMS),
  ...HIDDEN_NAV_ROUTE_ITEMS,
];
